import { adminUsersQueryKeys as e } from "./adminUsersQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { usersApi as n } from "@maat/api-main";
//#region src/users/admin/useAdminUserQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.adminGetUser(r),
	enabled: !!r
});
//#endregion
export { r as useAdminUserQuery };
